const dealsImages = [
    {
        img: "https://rb.gy/roxhw6",
        id: 1,
    },
    {
        img: "https://rb.gy/dzqy4g",
        id: 2,
    },
    {
        img: "https://rb.gy/ifldni",
        id: 3,
    },
    {
        img: "https://rb.gy/umtr1u",
        id: 4,
    },
    {
        img: "https://rb.gy/pnqwvr",
        id: 5,
    },

    {
        img: "https://rb.gy/qjeqds",
        id: 6,
    },
    {
        img: "https://rb.gy/dte9bg",
        id: 7,
    },
    {
        img: "https://rb.gy/3syy7v",
        id: 8,
    },
]
const roundImgCategory = [
    {
        id: 1,
        img: 'https://rb.gy/ahwhqe',
    },
    {
        id: 2,
        img: "https://rb.gy/dyygek",
    },
    {
        id: 3,
        img: "https://rb.gy/fummed",
    },
    {
        id: 4,
        img: "https://rb.gy/2h7fmx",
    },
    {
        id: 5,
        img: "https://rb.gy/zunwwd",
    },
    {
        id: 6,
        img: "https://rb.gy/cvjf0i",
    },
    {
        id: 7,
        img: "https://rb.gy/9jdxgt",
    },
    {
        id: 8,
        img: "https://rb.gy/pxfqw2",
    },
    {
        id: 9,
        img: "https://rb.gy/s8qukm",
    },
    {
        id: 10,
        img: "https://rb.gy/0isakj",
    },
]
const homeDecorImgs = [
    {
        id: 1,
        img: 'https://rb.gy/qrpome',
    },
    {
        id: 2,
        img: "https://rb.gy/alu2xc",
    },
    {
        id: 3,
        img: "https://rb.gy/qgnnsn",
    },
    {
        id: 4,
        img: "https://rb.gy/w5n8ml",
    },
]
const featureTrendsImgs = [
    {
        id: 1,
        img: 'https://rb.gy/umxcd3',
    },
    {
        id: 2,
        img: "https://rb.gy/i00afb",
    },
    {
        id: 3,
        img: "https://rb.gy/yudgxq",
    },
    {
        id: 4,
        img: "https://rb.gy/lik8wy",
    },
    {
        id: 5,
        img: "https://rb.gy/ifkrid",
    },
    {
        id: 6,
        img: "https://rb.gy/rzjtaq",
    },
    {
        id: 7,
        img: "https://rb.gy/qkbwde",
    },
    {
        id: 8,
        img: "https://rb.gy/faiffx",
    },
    {
        id: 9,
        img: "https://rb.gy/6vvvtj",
    },
    {
        id: 10,
        img: "https://rb.gy/gyvb7y",
    },
]
export { dealsImages, roundImgCategory, featureTrendsImgs, homeDecorImgs }